import useParent from 'context/parent-context/hook'
import PlanInfo from './PlanInfo'
import { Card, FC, useMemo} from 'external/react'
import HistoryTable from './HistoryTable'

const PaymentHistoryPage:FC = () => {

  const {state: {paymentHistory, paymentHistorySubscription: subscription}} = useParent()
  const lastInvoice = useMemo(() => paymentHistory.items[0] || false,[paymentHistory.items])

	return (
    <Card.Body>
      <PlanInfo subscription={subscription} lastInvoice={lastInvoice} />
      <div className='mt-2'>
        <p className='m-auto'>Historial de pagos</p>
      </div>
      <Card.Body>
        <div className='row'>
         <HistoryTable invoices={paymentHistory.items} />
        </div>
      </Card.Body>
    </Card.Body>
	)
}

export {PaymentHistoryPage as default}